import { __awaiter as w, __generator as A } from "./index11.js";
import { isOffline as I } from "./index13.js";
import { PersistedPriorityQueue as P } from "./index19.js";
import { toFacade as S } from "./index52.js";
import g from "./index57.js";
import q from "./index58.js";
import { normalize as k } from "./index59.js";
import { scheduleFlush as d } from "./index60.js";
import { PriorityQueue as E } from "./index24.js";
function F(i, e) {
  var l, t, n, u, a = i.user();
  return e.previousId = (n = (t = (l = e.previousId) !== null && l !== void 0 ? l : e.from) !== null && t !== void 0 ? t : a.id()) !== null && n !== void 0 ? n : a.anonymousId(), e.userId = (u = e.userId) !== null && u !== void 0 ? u : e.to, delete e.from, delete e.to, e;
}
function J(i, e, l) {
  var t, n, u, a;
  window.addEventListener("pagehide", function() {
    o.push.apply(o, Array.from(m)), m.clear();
  });
  var o = i.options.disableClientPersistence ? new E(i.queue.queue.maxAttempts, []) : new P(i.queue.queue.maxAttempts, "dest-Segment.io"), m = /* @__PURE__ */ new Set(), c = !1, h = (t = e?.apiHost) !== null && t !== void 0 ? t : "api.segment.io/v1", s = (n = e?.protocol) !== null && n !== void 0 ? n : "https", y = "".concat(s, "://").concat(h), b = ((u = e?.deliveryStrategy) === null || u === void 0 ? void 0 : u.strategy) === "batching" ? g(h, (a = e?.deliveryStrategy) === null || a === void 0 ? void 0 : a.config) : q();
  function v(r) {
    return w(this, void 0, void 0, function() {
      var _, f;
      return A(this, function(H) {
        return I() ? (o.push(r), d(c, o, p, d), [2, r]) : (m.add(r), _ = r.event.type.charAt(0), f = S(r.event).json(), r.event.type === "track" && delete f.traits, r.event.type === "alias" && (f = F(i, f)), [2, b.dispatch("".concat(y, "/").concat(_), k(i, f, e, l)).then(function() {
          return r;
        }).catch(function() {
          return o.pushWithBackoff(r), d(c, o, p, d), r;
        }).finally(function() {
          m.delete(r);
        })]);
      });
    });
  }
  var p = {
    name: "Segment.io",
    type: "after",
    version: "0.1.0",
    isLoaded: function() {
      return !0;
    },
    load: function() {
      return Promise.resolve();
    },
    track: v,
    identify: v,
    page: v,
    alias: v,
    group: v
  };
  return o.todo && d(c, o, p, d), p;
}
export {
  J as segmentio
};
//# sourceMappingURL=index37.js.map
